var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip,
    classes: 'badge-theme',
  }),expression:"{\n    content: tooltip,\n    classes: 'badge-theme',\n  }"}],class:_vm.badgeClass},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.type)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }